var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("7、企业出售无形资产发生的净损失，应当计入（　）。")])])
}]

export { render, staticRenderFns }